import React from "react";
import {PlusOutlined, SyncOutlined} from '@ant-design/icons';
import {Badge, Breadcrumb, Button, Card, Col, Divider, Form, Input, Row, Select, Space} from "antd";
import BaseComponent from "../../redare/components/BaseComponent";
import UserPresenter from "../../.gen/presenter/UserPresenter";
import UserForm from "../../components/user/UserForm";
import {WebPage} from "../../redare_components/webplatform_workbench/utils/WorkbenchDecoratorUtil";
import UserRoleForm from "../../components/user/UserRoleForm";
import UserPwdForm from "../../components/user/UserPwdForm";
import FunPermission from "../../redare_components/webplatform_workbench/components/permission/FunPermission";
import Window from "../../redare/components/modal/Window";
import UserStatusForm from "../../redare_components/webplatform_workbench/components/user/UserStatusForm";
import {Link} from "react-router-dom";
import ResizeGrid from "../../redare/components/grid/ResizeGrid";
import PlatformPresenter from "../../.gen/presenter/PlatformPresenter";


export default @WebPage({
    classify: '用户成员管理',
    id: 'com.redare.webmanager.pages.user.UserMemberManagementPage',
    name: '用户成员管理',
    des: '用户成员管理',
    webPath: [
        '/user/manager'
    ],
    webFunIds: [
        'modifyPwd',
        'modifyUser',
        'editCurrentUser',
        'addUser',
        'delUser',
        'updateUserRole',
        'WebPlatformUserModifyStatus'
    ],
    props: {
        user: '用户信息'
    }
})
class UserMemberManagementPage extends BaseComponent {

    constructor(props) {
        super(props);
        this.userPrestnter = new UserPresenter(this);
        this.platformPresenter = new PlatformPresenter(this)
    }

    componentDidMount() {
        this._findUserMemberPage();
        this._getRoleData();
    }

    _reloadUserMember() {
        this._findUserMemberPage()
    }

    _getRoleData() {
        this.platformPresenter.findPlatformRoleList(
            {},
            {},
            (result) => {
                let {data} = result;
                if (data) {
                    this.setState({roleList: data});
                }
            }
        )
    }

    //查询成员list
    _findUserMemberPage() {
        this.setGridLoading(true);
        if (!this.searchParams) {
            this.searchParams = {}
        }
        this.searchParams.platform = 'root';
        this.userPrestnter.findUserPage(
            this.searchParams,
            {curPage: this.curPage,},
            (result) => {
                let {data} = result;
                if (data && this.grid) {
                    let {result, curPage, pageSize, totalCount} = data;
                    this.grid.setData(result, {curPage, pageSize, totalCount})
                }
            },
            () => {
                this.setGridLoading(false)
            }
        )
    }

    //重置
    clearUserQuery() {
        this.curPage = 1;
        this.form.resetFields();
        this.searchParams = {};
        this._findUserMemberPage();
    }

    //分页
    onUserManagerPageChange(curPage) {
        this.curPage = curPage;
        this._findUserMemberPage()
    }

    //新增用户
    onAddUserClick() {
        this.userForm._show({title: "添加用户"});
    }

    //编辑
    onUserEditClick(id) {
        this.userForm._show({userId: id, title: "编辑用户"})
    }

    //修改角色
    onModifyUserRoleClick(id) {
        this.roleForm._show(id);
    }

    //修改密码
    onModifyUserPwdClick(id) {
        this.pwdForm._show(id);
    }

    //修改用户状态
    _modifyStatusClick({record, index}) {
        this._win = Window.show(
            <UserStatusForm
                id={record.accountId}
                onCancel={() => {
                    this._win.close();
                }}
                onSuccess={this._onEditSuccess.bind(this)}
            />,
            {title: '修改状态'});
    }

    _onEditSuccess() {
        this._win.close();
        this._findUserMemberPage();
    }

    //删除用户
    onUserDeleteClick(id) {
        this.confirm("您确定要该成员吗？", () =>{
            this.userPrestnter.delUser(
                {accountId: id},
                {},
                () => {
                    this.toastSuccess("删除成功");
                    this._findUserMemberPage();
                }
            )
        })
    }

    _onSearchFinish(values) {
        if (values.roleId) {
            values.roleIds = [values.roleId];
        }
        this.curPage = 1;
        this.searchParams = values;
        this._findUserMemberPage(values)
    }

    render() {
        let {roleList,syncSysUserLoading} = this.state;
        let selectRole = [];
        if (roleList && roleList.length > 0) {
            roleList.map(item => {
                selectRole.push(
                    <Select.Option key={item.id} value={item.id + ""}>{item.name}</Select.Option>
                )
            })
        }
        return (
            <div className="ReportPushConfiguration-Page">
                <div className="bg-white bord-bot">
                    <div className="width-all padding02">
                        <Breadcrumb>
                            <Breadcrumb.Item><Link to="/">工作台</Link></Breadcrumb.Item>
                            <Breadcrumb.Item><Link to="/site">系统设置</Link></Breadcrumb.Item>
                            <Breadcrumb.Item>用户管理</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
                <div className="width-all">
                    <div className="margin024">
                        <Card bordered={false} className="margin24 min-height" title="用户管理">
                            <div className="information-search-inline-wrap">
                                <Form
                                    ref={(o) => this.form = o}
                                    className="information-form" onFinish={this._onSearchFinish.bind(this)}>
                                    <Row gutter={24} justify="space-between">
                                        <Col span={18}>
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <Form.Item label="关键词" name="key">
                                                        <Input placeholder="请输入账号、姓名、电话" autoComplete="off"/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8}>
                                                    <Form.Item label="角色" name="roleId">
                                                        <Select placeholder="请选择" allowClear>
                                                            {selectRole}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Space>
                                                    <Form.Item>
                                                        <Button type="primary" htmlType="submit">查询</Button>
                                                    </Form.Item>
                                                    <Form.Item>
                                                        <Button onClick={() => this.clearUserQuery()}>重置</Button>
                                                    </Form.Item>
                                                </Space>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Form>
                                <FunPermission funId="addUser">
                                    <div style={{marginBottom: '24px'}}>
                                        <Button
                                          icon={<PlusOutlined/>}
                                          type="primary"
                                          onClick={() => this.onAddUserClick()}
                                        >添加用户</Button>
                                        <Button
                                          disabled={syncSysUserLoading}
                                          onClick={() => this._syncUser()}
                                          style={{marginLeft: '8px'}}
                                        >
                                            <div>
                                                <span style={{marginRight: '5px'}}>钉钉用户同步</span>
                                                <SyncOutlined spin={syncSysUserLoading} />
                                            </div>
                                        </Button>
                                    </div>
                                </FunPermission>
                            </div>

                            <ResizeGrid
                                ref={(o) => this.grid = o}
                                scroll={{x: 'max-content'}}
                                _initLoading={false}
                                bordered={false}
                                _onPageChange={(page) => {
                                    this.onUserManagerPageChange(page.curPage, page.pageSize)
                                }}
                                rowKey={(v) => v.id}
                                columns={[
                                    {
                                        title: '账号',
                                        dataIndex: 'account',
                                    },
                                    {
                                        title: '姓名',
                                        dataIndex: 'name',
                                    },
                                    {
                                        title: '角色',
                                        dataIndex: 'roleNames',
                                    },
                                    {
                                        title: '电话',
                                        dataIndex: 'mobile',
                                    },
                                    {
                                        title: '邮箱',
                                        dataIndex: 'email',
                                    },
                                    {
                                        title: '状态',
                                        dataIndex: 'status',
                                        render: (value) => {
                                            if (value === 0) {
                                                return <Badge text="正常" color="green"/>
                                            } else if (value === 1) {
                                                return <Badge text="注销" color="grey"/>
                                            } else {
                                                return <Badge text="锁定" color="red"/>
                                            }
                                        }
                                    },
                                    {
                                        title: '操作',
                                        width: 300,
                                        fixed: 'right',
                                        render: (text, record, index) => {
                                            return (
                                                <>
                                                    <FunPermission funId="modifyUser">
                                                        <a onClick={() => this.onUserEditClick(record.accountId)}>编辑</a>
                                                    </FunPermission>
                                                    <FunPermission funId="updateUserRole">
                                                        <Divider type="vertical"/>
                                                        <a onClick={() => this.onModifyUserRoleClick(record.accountId)}>修改角色</a>
                                                    </FunPermission>
                                                    <FunPermission funId="modifyPwd">
                                                        <Divider type="vertical"/>
                                                        <a onClick={() => this.onModifyUserPwdClick(record.accountId)}>修改密码</a>
                                                    </FunPermission>
                                                    {
                                                        window._workbench._user.id != record.id && (
                                                            <>
                                                                <FunPermission funId="WebPlatformUserModifyStatus">
                                                                    <Divider type="vertical"/>
                                                                    <a onClick={this._modifyStatusClick.bind(this, {
                                                                        record,
                                                                        index
                                                                    })}>修改状态</a>
                                                                </FunPermission>
                                                                <FunPermission funId="delUser">
                                                                    <Divider type="vertical"/>
                                                                    <a onClick={this.onUserDeleteClick.bind(this, record.accountId)}>删除</a>
                                                                </FunPermission>
                                                            </>
                                                        )
                                                    }
                                                </>
                                            )
                                        }
                                    }
                                ]}/>
                        </Card>
                        <UserForm ref={(o) => this.userForm = o} parentComponent={this}/>
                        <UserRoleForm ref={(o) => this.roleForm = o} parentComponent={this}/>
                        <UserPwdForm ref={(o) => this.pwdForm = o} parentComponent={this}/>
                    </div>
                </div>
            </div>
        );
    }

    setGridLoading(bool) {
        if (this.grid) {
            bool ? this.grid.showLoadingIndicator() : this.grid.closeLoadingIndicator()
        }
    }

    _syncUser(){
        this.setState({syncSysUserLoading: true});
        this.userPrestnter.syncSysUser(
          {},
          (result) => {
              let {message} = result;
              let content = <p>{message}</p>;
              this.alertSuccess(content, {
                  title: '钉钉用户同步成功', onOk: () => {this.clearUserQuery()}
              });
              this.setState({syncSysUserLoading: false});
          },
          () => {
              this.setState({syncSysUserLoading: false});
          }
        )
    }

}
